export default __webpack_public_path__ + "static/media/image1.b6907317.png";